// src/pages/About.js
import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import "./about.css";

const AboutUs = () => {
  return (
    <div className="aboutus-page py-5">
      <Container>
        <h2 className="text-center mt-5">About Us</h2>
        <p className="text-center lead">Get to know us!</p>

        <Row className="align-items-center mt-4">
          {/* Left Side Image */}
          <Col md={5} className="mb-4 mb-md-0">
            <Image
              src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg"
              alt="About Company"
              fluid
              rounded
              className="about-image shadow"
            />
          </Col>

          {/* Right Side Content */}
          <Col md={7}>
            <Card className="p-4 shadow-sm ">
              <Card.Body>
                <p>
  <strong>VAIBHAVAM</strong> is a service platform for{" "}
  <strong>wedding venues</strong> and <strong>vendors</strong>, and it is a
  proud product of <strong>BION Technology Solution</strong>. Established in{" "}
  <strong>2025</strong> at <strong>Coimbatore</strong>, our mission is to
  simplify wedding planning by connecting customers with trusted venues and
  reliable service providers.
</p>

<p>
  At present, we provide services across <strong>India</strong>. We focus on
  helping our customers save time and effort by offering verified vendor
  listings, clear venue details, and seamless booking support—all in one place.
</p>

<p>
  When you choose <strong>VAIBHAVAM</strong>, you are assured of{" "}
  <strong>quality, trust, and convenience</strong> for one of the most
  important occasions of your life.
</p>


                <hr />

                <div className="company-info">
                  <p>
                    <strong>Technology Partner : </strong> BION TECHNOLOGY SOLUTION
                  </p>
                 
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutUs;
